export function resolveSituacaoDefault({ operacao, profile }) {
    if (!operacao) return null;

    const sigla = operacao.sigla?.toLowerCase();

    // 🔵 exemplos (você ajusta conforme sua regra real)

    // orçamentos
    if (['omp', 'odc', 'oser', 'odv'].includes(sigla)) {
        return 'Orçamento';
    }

    // conferência
    if (sigla === 'cfr') {
        return 'Aguardando Conferência';
    }

    // locação / imóveis
    if (sigla === 'lim') {
        return 'Locado';
    }

    // restaurante
    if (sigla === 'rest') {
        return 'Aberto';
    }

    // fallback padrão
    return 'Aberto';
}
